// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"135":"7530d92d","568":"2cbb1acc","991":"b5d0bb1f"}[chunkId] + ".css";
};